import { render, staticRenderFns } from "./icon.vue?vue&type=template&id=0ee0b398&scoped=true&"
var script = {}
import style0 from "./icon.vue?vue&type=style&index=0&id=0ee0b398&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ee0b398",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JG\\jg\\IWMS5.0\\SRM\\GIT\\SRM.VUE\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ee0b398')) {
      api.createRecord('0ee0b398', component.options)
    } else {
      api.reload('0ee0b398', component.options)
    }
    module.hot.accept("./icon.vue?vue&type=template&id=0ee0b398&scoped=true&", function () {
      api.rerender('0ee0b398', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/demo/components/icon/icon.vue"
export default component.exports